import Swiper from 'swiper';
// import { EffectFade } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default class ShapesCarousel {
  constructor({ el }) {
    this.el = el;
    this.carouselEl = this.el.querySelector('.swiper');
    this.title = this.el.querySelector('.title');
    this.buttons = Array.from(this.el.querySelectorAll('.button-pickers button'));

    this.init();
  }

  init() {
    if (this.carouselEl) {
      this.carousel = new Swiper(this.carouselEl, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 15,
        // effect: 'fade',
        // fadeEffect: {
        //   crossFade: true,
        // },
        // modules: [EffectFade],
      });

      this.carousel.on('realIndexChange', () => {
        this.buttons.forEach((button) => {
          button.classList.remove('active');
        });

        this.buttons[this.carousel.realIndex].classList.add('active');
        this.title.innerHTML = this.buttons[this.carousel.realIndex].dataset.title;
      });

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.carousel.slideToLoop(index);
        });
      });
    }
  }
}
